import { render, staticRenderFns } from "./AccountComponent.vue?vue&type=template&id=436ebb2a&scoped=true&"
import script from "./AccountComponent.vue?vue&type=script&lang=ts&"
export * from "./AccountComponent.vue?vue&type=script&lang=ts&"
import style0 from "./AccountComponent.vue?vue&type=style&index=0&id=436ebb2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436ebb2a",
  null
  
)

export default component.exports